import gql from 'graphql-tag';

export const GET_NICKNAME = gql`
  query GetNickname($planId: Int!) {
    plan(id: $planId) {
      id
      name
    }
  }
`;

export const UPDATE_NICKNAME = gql`
  mutation UpdatePlan($id: Int!, $input: UpdatePlanInput!) {
    updatePlan(id: $id, input: $input) {
      id
      name
      displayName
    }
  }
`;

export const getNicknameMock = {
  plan: {
    id: 20,
    name: 'old nickname',
  },
};

export const updateNicknameMock = {
  updatePlan: {
    displayName: 'new nickname',
    id: 20,
    name: 'new nickname',
  },
};
